<template>
  <div class="city" :class="classList">
    <div class="city__stage">
      <component
        :is="scene.component"
        :delay="scene.delay"
        v-for="scene in scenes"
        :area="scene.area"
        :class="`stage-${viewName}__${scene.name}`"
        :key="`stage-${viewName}__${scene.name}`"
      ></component>
    </div>
  </div>
</template>

<script>
  import { viewNames } from '@/ulils/responsive.breakpoints'

  const scenes = {
    [viewNames.COMPACT]: [
      { name: 'intro', delay: 500, area: false, component: require('@/components/City/Scenes/IntroMobile.vue').default },
      { name: 'office', area: false, component: require('@/components/City/Scenes/OfficeMobile.vue').default },
      { name: 'mall', area: false, component: require('@/components/City/Scenes/MallMobile.vue').default },
      { name: 'factory', area: false, component: require('@/components/City/Scenes/FactoryMobile.vue').default },
      { name: 'crossroad', area: false, component: require('@/components/City/Scenes/CrossroadMobile.vue').default },
      { name: 'stadium', area: false, component: require('@/components/City/Scenes/StadiumMobile.vue').default },
      { name: 'hospital', area: false, component: require('@/components/City/Scenes/HospitalMobile.vue').default },
      { name: 'final', area: false, component: require('@/components/City/Scenes/FinalMobile.vue').default },
    ],
    [viewNames.FULL]: [
      { name: 'intro', delay: 300, area: false, component: require('@/components/City/Scenes/IntroDesktop.vue').default },
      { name: 'office', area: false, component: require('@/components/City/Scenes/OfficeDesktop.vue').default },
      { name: 'mall', area: false, component: require('@/components/City/Scenes/MallDesktop.vue').default },
      { name: 'factory', area: false, component: require('@/components/City/Scenes/FactoryDesktop.vue').default },
      { name: 'crossroad', area: false, component: require('@/components/City/Scenes/CrossroadDesktop.vue').default },
      { name: 'stadium', area: false, component: require('@/components/City/Scenes/StadiumDesktop.vue').default },
      { name: 'hospital', area: false, component: require('@/components/City/Scenes/HospitalDesktop.vue').default },
      { name: 'final', area: false, component: require('@/components/City/Scenes/FinalDesktop.vue').default },
    ],
  }

  export default {
    props: {
      back: { type: Boolean, default: false }
    },
    computed: {
      viewName () {
        return this.$store.getters.view
      },
      scenes () {
        return scenes[this.viewName].slice(0, this.current + 1)
      },
      current () {
        const current = this.$store.state.current
        return current === null ? 0 : current + 1
      },
      scene () {
        return scenes[this.current]
      },
      classList () {
        return {
          'back': this.back
        }
      }
    }
  }
</script>

<style lang="scss">
  .city {
    overflow: hidden;
  }

  .city__stage {
    position: relative;
    left: 50%;
    transform: translateX(-50%);

    .city.back & {
      background-position: 50% 0%;
      background-repeat: no-repeat;

      @include more(scale) {
        background-image: url('~@/components/Map/back.png')
      }
      @include mq(scale) {
        background-size: 100%;
      }
      @include less(tablet) {
        background-size: 100%;
        background-image: url('~@/components/Map/back_mobile.png')
      }
    }

    // Desktop view
    @include more(scale) {
      @include relative-units($map-width-desktop, $map-height-desktop, desktop)
    }
    @include mq(desktop) {
      width: $map-width-desktop;
    }
    @include mq(scale) {
      width: 100%;
      max-width: $map-width-desktop;
    }

    // Mobile view
    @include less(tablet) {
      min-width: $map-width-mobile;
      max-width: $map-width-mobile;
      @include relative-units($map-width-mobile, $map-height-mobile, mobile)
    }
  }

  .stage-desktop__intro {
    @include realtive-scene(30px, 571px, desktop)
  }
  .stage-desktop__office {
    @include realtive-scene(1204px, 39px, desktop)
  }
  .stage-desktop__mall {
    @include realtive-scene(2260px, 480px, desktop)
  }
  .stage-desktop__factory {
    @include realtive-scene(3374px, 8px, desktop)
  }
  .stage-desktop__crossroad {
    @include realtive-scene(4464px, 566px, desktop)
  }
  .stage-desktop__stadium {
    @include realtive-scene(5496px, -129px, desktop)
  }
  .stage-desktop__hospital {
    @include realtive-scene(6666px, 629px, desktop)
  }
  .stage-desktop__final {
    @include realtive-scene(8102px, 81px, desktop)
  }

  .stage-mobile__intro {
    @include realtive-scene(408px, 54px, mobile)
  }
  .stage-mobile__office {
    @include realtive-scene(926.5px, 17px, mobile)
  }
  .stage-mobile__mall {
    @include realtive-scene(1740.49px, 44.56px, mobile)
  }
  .stage-mobile__factory {
    @include realtive-scene(2579.24px, 35.75px, mobile)
  }
  .stage-mobile__crossroad {
    @include realtive-scene(3281.4px, 55.2px, mobile)
  }
  .stage-mobile__stadium {
    @include realtive-scene(4155.88px, 29.62px, mobile)
  }
  .stage-mobile__hospital {
    @include realtive-scene(4973px, 32.05px, mobile)
  }
  .stage-mobile__final {
    @include realtive-scene(5960px, 159px, mobile)
  }
</style>
